import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Badge } from '@/components/ui/badge';

export const NursingNoteBadge: FC = () => {
  const { t } = useTranslation(['component']);
  return (
    <Badge className="bg-emerald-400 font-semibold text-foreground">
      {t('component:badge.nursingNote')}
    </Badge>
  );
};
